import { useMemo } from "react";
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement,
  LineElement, Filler, Title, Tooltip, Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Title, Tooltip, Legend);

const MONTHS_SHORT = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];

export function UsersChart({ users, height = "250px" }) {
  const currentYear = new Date().getFullYear();

  const byMonth = useMemo(() => {
    const counts = new Array(12).fill(0);
    users.forEach(u => {
      const d = new Date(u.created_at);
      if (d.getFullYear() === currentYear) counts[d.getMonth()]++;
    });
    return counts;
  }, [users, currentYear]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        position: "top",
        labels: { font: { size: 11 }, usePointStyle: true, pointStyleWidth: 8, padding: 16, color: "#718096" },
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,.82)",
        titleFont: { size: 12, weight: "600" },
        bodyFont: { size: 11 },
        padding: 10,
        cornerRadius: 8,
      },
    },
    scales: {
      x: { grid: { color: "rgba(0,0,0,.04)" }, ticks: { font: { size: 10 }, color: "#a0aec0" } },
      y: {
        grid: { color: "rgba(0,0,0,.04)" },
        ticks: { font: { size: 10 }, color: "#a0aec0", stepSize: 1 },
        beginAtZero: true,
      },
    },
  };

  const data = {
    labels: MONTHS_SHORT,
    datasets: [
      {
        fill: true,
        label: "Novos usuários",
        data: byMonth,
        borderColor: "#8e44ad",
        backgroundColor: "rgba(142,68,173,.12)",
        borderWidth: 2,
        tension: 0.4,
        pointRadius: 3,
        pointHoverRadius: 5,
      },
    ],
  };

  return (
    <div style={{ height, width: "100%", position: "relative" }}>
      <Line options={options} data={data} />
    </div>
  );
}
